import React, { Component } from "react"
import LeftArrow from "../images/arrow-slider-left.svg"
import RightArrow from "../images/arrow-slider-right.svg"
import playVideo from "../images/play-video.svg";

class LandingVideoText extends Component {

  render() {
    const layout = this.props.content
    return (
      layout.field_video_id != '' || layout.field_description_wysiwyg !== '' ? (
        <div className="container">
          <div data-uk-grid>
            {layout.field_video_id ? (
              <div className="uk-width-2-3@m uk-flex page-311-video-column" data-uk-lightbox>
                <a className="uk-inline yt-modal-video-open" href={"https://www.youtube.com/watch?v="+layout.field_video_id}>
                  <img src={`https://i1.ytimg.com/vi/` + layout.field_video_id + `/maxresdefault.jpg`} alt=""/>
                </a>
                <img className="page-311-video-column-play-icon" src={playVideo} alt="Play icon"/>
              </div>
            ) : (
              null
            )}
            <div className="uk-width-expand@m uk-flex uk-flex-column page-311-video-section-content" dangerouslySetInnerHTML={{ __html: layout?.field_description_wysiwyg?.value }} />
          </div>
        </div>
      ) : (
        null
      )
    )
  }
}

export default LandingVideoText
